import { useCallback } from 'react';
import { API_ENDPOINTS } from '../config/api/apiCall';
import { billOfMaterialPlanCRUD } from '../services/billOfMaterialService';

const usePlanBomCRUD = (callMessage) => {
    const processIndent = useCallback(async (selectedMode, editRequestIndentID, requestBody) => {
        try {
            const apiEndpoint = selectedMode === 0
                ? API_ENDPOINTS.BILL_MATERIAL_PLAN_CRUD
                : API_ENDPOINTS.APPROVED_INDENT_CRUD_PROCESS;

            const successMessage = selectedMode === 0
                ? (editRequestIndentID !== 0 
                    ? 'Plan updated Successfully' 
                    : 'New Plan Created Successfully')
                : 'Request indent Approved Successfully';

            // Await the API response
            const data = await billOfMaterialPlanCRUD(apiEndpoint, requestBody);
            
            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processIndent };
};

export default usePlanBomCRUD;

